import React, { useEffect, useState, useRef } from 'react';
import { areEqual } from '../../util';
import { ServiceErfa } from '../../services/service-erfa';
import { NotificationManager } from 'react-notifications';
import { ServiceCheckExtension } from '../../services/service-check-file-extension';
import { getUID } from '../../global/app';
import StarRating from '../../components/shared/Rating';
import RateQuestion from './rateQuestion';
import BtDropdown from './../bt-select/bt-select';
import BtButton from '../bt-button/bt-button';
import appState from '../../state/AppStateContainer';

import '../app-chat-mail-batch/app-chat-mail-batch.css';
import '../app-select-industry-types/app-select-industry-types.css';
import './rating-form.css';
import BackButton from '../../components/shared/BackButton/BackButton';
import BtRow from '../bt-row/bt-row';
import BtColumn from '../bt-column/bt-column';
import BtGrid from '../bt-grid/bt-grid';
import File from '../../components/File/File';
import AppLayout from '../../components/layout/app-layout/app-layout';

const Ratingform = React.memo(function RatingForm(props) {
  // --------States
  const [reqError, setRequiredError] = useState('');
  const [erfaData, setErfaData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [processForm, setProcessForm] = useState(false);
  const [content, setContent] = useState('');
  const [files, setFiles] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [projectsArr, setProjectsArr] = useState([]);
  const [usersArr, setUsersArr] = useState([]);
  const [erfaArr, setErfaArr] = useState([]);
  const [currentProject, setCurrentProject] = useState('');
  const [currentUser, setCurrentUser] = useState('');
  const [mainUserArr, setMainUserArr] = useState([]);

  async function fetchData(id) {
    if (!erfaData) {
      const _erfaData = await ServiceErfa.getErfa(id);
      if (_erfaData.error) {
        NotificationManager.error(_erfaData.error.message, 'Fel');
        return;
      }
      setErfaData(_erfaData);
      setContentData(_erfaData.other);
      if (_erfaData.isRated) {
        setDisableBtn(true);
      }
    }
  }

  useEffect(() => {
    (async () => {
      let checkPath = window.location.pathname.split('/');
      if (checkPath.pop() !== 'true') {
        setLoader(true);
        const _id = window.location.pathname.split('/').pop();

        await fetchData(_id);
        setLoader(false);
      } else {
        let supplierId = checkPath.pop();
        if (!projectsArr.length) {
          try {
            const data = await ServiceErfa.getErfaForSupplier(supplierId);
            const { projectsArr, userArr, erfaData } = data;
            setMainUserArr(userArr.map(u => ({...u, label: u.areaName + " utvärderat av " + u.userName })));
            setErfaArr(erfaData);
            setUsersArr(userArr.map(u => ({...u, label: u.areaName + " utvärderat av " + u.userName })));
            setProjectsArr(projectsArr);
            setDisableBtn(true);
            setCurrentProject(projectsArr[0].value);
            setData(projectsArr[0].value, erfaData);
            setUser(projectsArr[0].value);
          } catch (e) {
            console.log(e, ':::::ERROR:::::');
            NotificationManager.error(e.error);
          }
        }
      }
    })()
  }, [files, newFiles, erfaArr, erfaData, usersArr, currentUser]);

  const elInputFile = useRef(null);
  const userSelect = useRef(null);

  const setData = (project, erfaArr) => {
    const checkErfa = isExists(erfaArr, 'projectId', project);
    if (checkErfa.length) {
      setContentData(checkErfa[0].other);
      setErfaData(checkErfa[0]);
    }
  };

  const setUser = project => {
    let filterUser =
      mainUserArr && mainUserArr.length
        ? mainUserArr.filter(user => {
            return user.projectId == project;
          })
        : [];
    if (filterUser.length) {
      if (userSelect && userSelect.current) {
        userSelect.current.labelValue = filterUser[0].label;
        userSelect.current.state.labelValue = filterUser[0].label;
        userSelect.current.value = filterUser[0].value;
      }
      setUsersArr(filterUser);
      setCurrentUser(filterUser[0] && filterUser[0].value);
      onChangeUser(filterUser[0] && filterUser[0].label);
    }
  };

  const isExists = (arr, key, search) => {
    return arr.filter(function (el) {
      return el[key] === search;
    });
  };

  const setContentData = content => {
    if (content) {
      setContent(content);
      return;
    }
    setContent('');
  };

  const getFileObject = item => {
    return {
      id: getUID(),
      fileId: item.fileId || item._id,
      fileName: item.name || item.fileName,
      mimeType: item.type,
      fileObj: item._id ? {} : item,
    };
  };

  const elInputFileChangeCallback = e => {
    var arr = [];
    var _files = e.target.files;
    for (let i = 0; i < _files.length; i++) {
      let isValid = ServiceCheckExtension.checkFileExtension(_files[i]);

      if (isValid) {
        var fileObj = getFileObject(_files[i]);
        arr.push(fileObj);
        newFiles[fileObj.id] = fileObj;
      } else {
        NotificationManager.error(` Det gick inte att ladda upp den här filen`);
      }
    }

    setFiles([...files, ...arr]);
    setNewFiles(newFiles);
  };

  const generateUploadedFiles = item => {
    // console.log(item, 'item');
    return (
      <div className="item-overflow" key={item.id}>
        <div className="item">
          <svg
            onClick={uploadItemRemoveClickCallback}
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
          >
            <g fill="none" fillRule="evenodd">
              <path
                fill="red"
                fillRule="nonzero"
                d="M7,0 C10.8593333,0 14,3.14066667 14,7 C14,10.8593333 10.8593333,14 7,14 C3.14066667,14 0,10.8593333 0,7 C0,3.14066667 3.14066667,0 7,0 Z"
              />
              <rect width="8" height="2" x="3" y="6" fill="#FFF" />
            </g>
          </svg>
          <File
            disabled
            key={`filename${item.id}`}
            fileName={item.fileName || item.file}
            file={item.fileName || item.file}
          />
        </div>
      </div>
    );
  };

  const uploadItemRemoveClickCallback = e => {
    if (files && files.length > 0) {
      var target = e.target;
      var item = target.closest('.item-overflow');
      const index = [...item.parentElement.children].indexOf(item);
      var file = files[index];
      delete newFiles[file.id];
      files.splice(index, 1);

      setFiles([...files]);
      setNewFiles(newFiles);
    }
  };

  const setComment = (e, i) => {
    let cloneErfa = erfaData;
    cloneErfa.questions[i].comment = e;
    setErfaData(cloneErfa);
  };

  const setRating = (e, i) => {
    let cloneErfa = erfaData;
    cloneErfa.questions[i].rating = e;
    setErfaData(cloneErfa);
  };

  const isRatingFilled = () => {
    var index = -1;
    for (var i = 0; i < erfaData.questions.length; i++) {
      if (!erfaData.questions[i].rating) {
        index = i;
        break;
      }
    }
    return index;
  };

  const submitRatings = async () => {
    if(disableBtn) return;
    const checkRating = isRatingFilled();
    if (checkRating !== -1) {
      setRequiredError('Vänligen betygsätt alla frågor');
      setTimeout(() => setRequiredError(''), 2000);
      return;
    }
    setProcessForm(true);
    let dataToSend = {
      files: files,
      other: content,
      erfaData,
    };
    const result = await ServiceErfa.submitRating(dataToSend);
    if (result.error) {
      setProcessForm(false);
      NotificationManager.error(result.error);
    }
    setDisableBtn(true);
    setProcessForm(false);
    NotificationManager.success(result.message);
  };

  const onChangeProject = (value, type) => {
    setUser(value);
    setCurrentProject(value);
    setData(value, erfaArr);
  };

  const onChangeUser = (value, type) => {
    setCurrentUser(value);
    let filteredErfa = erfaArr.find(el => {
      return el.userEmail + '-' + el.areaName == value && el.projectId == currentProject;
    });
    if (filteredErfa) {
      setContentData(filteredErfa.other);
      setErfaData(filteredErfa);
    }
  };

  function renderContent() {
    const { supplierName, projectName, projectNumber } = erfaData;
    return (
      <BtGrid>
        <BtRow>
          <BtColumn style={{marginLeft: "32px"}}>
            <div className="rating-form-card status-idle hydrated ">
              <div className="">
                <BtRow className="header card-header">
                  <BtColumn>
                    <label>{supplierName}</label>
                    <br />
                    <label style={{ fontSize: '1.3em' }}>Erfarenhetsåterföringsformulär</label>
                  </BtColumn>
                </BtRow>              
                <BtRow>
                  <BtColumn>
                    {projectsArr && projectsArr.length > 0 && (<>
                        <div className="card-information">
                          <span className="headline-label">Projekt {projectsArr.length > 0 && `(${projectsArr.length})`}</span>
                          <div className="bt-select-wrapper notranslate">
                            <BtDropdown
                              // ref={(el) => (this.btSelectState = el)}
                              labelValue={projectsArr[0].label}
                              data={projectsArr}
                              name={'projectName'}
                              handleChange={onChangeProject}
                              value={currentProject}
                            />
                          </div>
                        </div>
                    </>)}
                  </BtColumn>
                  {usersArr && usersArr.length > 0 && (
                    <BtColumn>
                      <div className="card-information">
                        <span className="headline-label">Utvärdering</span>
                        <div className="notranslate">
                          <BtDropdown
                            ref={userSelect}
                            description=""
                            labelValue={usersArr[0] && usersArr[0].label}
                            data={usersArr && usersArr.length ? usersArr : []}
                            name={'label'}
                            handleChange={onChangeUser}
                            value={currentUser}
                          />
                        </div>
                      </div>
                    </BtColumn>
                  )}
                </BtRow>
                <div className="container--quo">
                  <BtRow>
                    <BtColumn>
                      <div className="card-information">
                        <span className="headline-label">Projektnamn</span>
                        <span className="headline-info">{projectName}</span>
                      </div>
                    </BtColumn>

                    <BtColumn>
                      <div className="card-information">
                        <span className="headline-label">Projektnummer</span>
                        <span className="headline-info">{projectNumber}</span>
                      </div>
                    </BtColumn>

                  </BtRow>
                </div>
              </div>
              <div className="fm-group">
                <div className="erfaRating">
                  <div className="rating-div">
                    <StarRating
                      rating={1}
                      numberOfStars={1}
                      style={{ marginTop: 'unset' }}
                      emptySymbol={`fa fa-star-o fa-2x medium`}
                      fullSymbol={`fa fa-star fa-2x medium`}
                      readOnly={true}
                      noNumber
                    />
                    <span className="minStarLabel">Mycket dåligt</span>
                    <span className="maxStarLabel">Mycket Bra</span>
                    <StarRating
                      rating={5}
                      numberOfStars={5}
                      style={{ marginTop: 'unset' }}
                      emptySymbol={`fa fa-star-o fa-2x medium`}
                      fullSymbol={`fa fa-star fa-2x medium`}
                      readOnly={true}
                      noNumber
                    />
                  </div>
                </div>

                <div className="upload-files-wrapper uploaded-files">
                  {files &&
                    files.map(item => {
                      return generateUploadedFiles(item);
                    })}
                </div>
              </div>
              {erfaData &&
                erfaData.questions &&
                erfaData.questions.map((question, i) => {
                  return (
                    <RateQuestion
                      isDisabled={disableBtn}
                      key={question._id}
                      scrollId={i}
                      question={question.question}
                      comment={question.comment || ''}
                      rating={question.rating || 0}
                      setComment={e => setComment(e, i)}
                      onRating={e => setRating(e, i)}
                    />
                  );
                })}
                <label>Övrigt</label>
                <div className="message-wrapper">
                  <textarea
                    className="rating-input"
                    value={content}
                    disabled={disableBtn}
                    onChange={e => setContent(e.target.value)}
                  ></textarea>
                </div>

              <div className="rating-btn">
                {reqError && (
                  <span className="error show" style={{ color: 'red', paddingRight: 12 }}>
                    {reqError}
                  </span>
                )}
                <BtButton
                  class={`btn-send m-t-25 bt-align-right hydrated ${
                    processForm ? 'loader-show' : ''
                  }`}
                  loaderShow={processForm}
                  onClick={submitRatings}
                  disabled={disableBtn}
                  id="btn"
                  rightIcon={<svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="32"
                    viewBox="0 0 33 32"
                  >
                    <path
                      d="M32.5806839,14.6066047 L1.00578206,0.0575495956 C0.981383271,0.0459103516 0.95554926,0.0459103516 0.929715249,0.038635824 C0.888093788,0.0240867689 0.846472326,0.0109926194 0.803415642,0.00517299736 C0.760358958,-0.00064662467 0.720172719,-0.00064662467 0.677116034,0.000808280837 C0.638365018,0.00371809185 0.601049225,0.00662790286 0.562298209,0.0153573359 C0.519241525,0.0240867689 0.480490509,0.0371809185 0.441739493,0.0531848791 C0.418775928,0.0633692176 0.39437714,0.0648241231 0.371413575,0.0764633672 C0.354190902,0.0851928002 0.344144342,0.0997418553 0.328356891,0.109926194 C0.296781989,0.130294871 0.269512756,0.153573359 0.242243522,0.178306753 C0.203492506,0.213224485 0.169047159,0.248142217 0.13890748,0.288879571 C0.130296143,0.300518815 0.117379138,0.307793343 0.108767801,0.320887492 C0.098721241,0.335436547 0.0972860182,0.352895414 0.0886746813,0.368899374 C0.0642758935,0.414001445 0.0441827741,0.460558421 0.029830546,0.511480114 C0.0183487635,0.54494294 0.0111726494,0.578405767 0.00686698098,0.613323499 C0.00112608973,0.656970664 -0.0017443559,0.70061783 0.00112608973,0.7457199 C0.00256131254,0.78791216 0.00686698098,0.83010442 0.0154783179,0.870841774 C0.0183487635,0.889755546 0.0154783179,0.908669317 0.0212192091,0.927583089 L8.63255608,30.0256932 C8.69570589,30.2395643 8.85070995,30.4126981 9.05594681,30.4941728 C9.14206018,30.5276356 9.231044,30.5450945 9.32002781,30.5450945 C9.44632742,30.5450945 9.5711918,30.5116317 9.68170396,30.4461609 L16.9137917,26.1570995 L23.195762,31.8166819 C23.2316425,31.8486898 23.2746992,31.8646938 23.3134502,31.8894272 C23.3450251,31.908341 23.3722944,31.9316194 23.4067397,31.9461685 C23.4914179,31.9810862 23.5804017,32 23.6722559,32 C23.7612398,32 23.8487883,31.9796313 23.9334665,31.9461685 C23.9406426,31.9432587 23.9492539,31.9418038 23.9564301,31.938894 C23.975088,31.9301645 23.9894402,31.9141606 24.0066629,31.9039762 C24.0109685,31.9025213 24.013839,31.8996115 24.0167094,31.8967017 C24.0554604,31.8748781 24.0970819,31.8603291 24.1329625,31.8297761 C24.143009,31.8210466 24.1473147,31.8094074 24.155926,31.8006779 C24.168843,31.7890387 24.1803248,31.7788544 24.1918066,31.7657602 C24.1961123,31.7599406 24.2032884,31.7584857 24.2090293,31.7526661 C24.2233815,31.7366621 24.2276872,31.7148385 24.2406042,31.6973797 C24.2678734,31.6595521 24.2937074,31.6231795 24.3138005,31.5824421 C24.3224119,31.5635283 24.3310232,31.5475244 24.3381993,31.5286106 C24.3468107,31.5038772 24.3525516,31.4791438 24.3582924,31.4544104 C24.3697742,31.4078535 24.3769503,31.3627514 24.3798208,31.3147395 C24.381256,31.2987355 24.3884321,31.2856414 24.3884321,31.2696374 L24.3884321,22.176478 L32.7127244,15.8476391 C32.9150908,15.6934191 33.0241678,15.4431753 32.9954633,15.187112 C32.9696293,14.9354133 32.8103196,14.7128128 32.5806839,14.6066047 Z M9.3981305,29 L2,4 L18,23.8975386 L9.3981305,29 Z M18,25.5557963 L18.6914894,25 L20,28 L18,25.5557963 Z M22.9985353,29 L20.0091542,24.0280465 C19.9827902,23.9286659 19.9359209,23.8336697 19.870011,23.7532883 L7,8 L23,22.4686478 L23,29 L22.9985353,29 Z M23.9090909,21 L5,3 L31,15.4130219 L23.9090909,21 Z"
                      transform="matrix(-1 0 0 1 33 0)"
                    ></path>
                  </svg>}
                >
                  Skicka                  
                </BtButton>
              </div>
            </div>
          </BtColumn>
        </BtRow>
      </BtGrid>
    );
  }

  const page = (
    <div className="general--page--content page--quotation">
      <BtGrid>
        <BtRow>
          <BtColumn>
            <BtGrid>
              <BtRow>
                <BtColumn>{erfaData && renderContent()}</BtColumn>
              </BtRow>
            </BtGrid>
          </BtColumn>
        </BtRow>
      </BtGrid>
    </div>
  );

  if (appState.isCustomerUser() && usersArr?.length > 0) {
    return <AppLayout 
      title={<BackButton
        style={{ alignSelf: 'center', margin: '0 20px' }}
        onClick={() => window.history.back()}
        path={["Erfarenhetsåterföringsformulär"]}
      />}

      >
        {page}
      </AppLayout>
  } else {
    return page;
  }


}, areEqual);

export default Ratingform;
